import * as filestack from 'filestack-js';

// Initialize Filestack client with the API key
export const filestackClient = filestack.init('AbWBvsKDKTkqSnuVP4OVGz');

/**
 * Extracts the Filestack handle from a Filestack URL
 * @param {string} url - The Filestack URL
 * @returns {string} The Filestack handle
 */
export const getFilestackHandle = (url) => {
  if (!url) return '';
  const urlParts = url.split('/');
  return urlParts[urlParts.length - 1];
};

/**
 * Generates a transformed image URL for different sizes and use cases
 * @param {string} url - The original Filestack URL or handle
 * @param {string} size - The size variant ('favicon', 'thumbnail', 'gallery', 'full', 'original')
 * @returns {string} The transformed URL
 */
export const getTransformedImageUrl = (url, size = 'gallery') => {
  if (!url) return '';
  
  // If it's already a transformed URL, extract the handle
  const handle = url.includes('filestackcontent.com') ? getFilestackHandle(url) : url;
  
  // Return the original URL if no handle is found
  if (!handle) return url;
  
  // Define transformation parameters for different sizes
  const transformations = {
    favicon: 'resize=width:32,height:32,fit:crop/quality=value:100/output=format:png',
    thumbnail: 'resize=width:300,height:300,fit:crop/quality=value:80',
    app: 'resize=width:600,fit:max/quality=value:90',
    gallery: 'resize=width:1200,fit:max/quality=value:85',
    full: 'resize=width:1920,fit:max/quality=value:90',
    original: ''
  };
  
  const transform = transformations[size] || transformations.gallery;
  
  // If original size is requested, return the original URL
  if (size === 'original') {
    return `https://cdn.filestackcontent.com/${handle}`;
  }
  
  // Return the transformed URL
  return `https://cdn.filestackcontent.com/${transform}/${handle}`;
};

export default {
  filestackClient,
  getFilestackHandle,
  getTransformedImageUrl
}; 